import usePost from '../usePost';
import {IUser, IUserRegisterParams} from './useUser';
import useGet from '../useGet';
import {IQueryByIdParams} from '../../utils/HttpInstance';
import {IKnowledgeTest} from './useKnowledgeTest';
import {IContest} from './useContest';

export interface IContestNotice {
  isHide: boolean;
  title: string;
  content: string;
  publishedDate: string;
  id: number;
  createdTime: string;
  contest: IContest;
}

export interface IContestSaveParams {
  id?: number;
  contestId: number;
  title: string;
  content: string;
  publishedDate: string;
  isHide: boolean;
}

export interface IContestListParams {
  contestId: number;
  includeHide?: boolean;
}

export default class UseContestNotice {
  static save() {
    return usePost<IContestSaveParams, IContestNotice>('contestNotice/save', {});
  }
  static list() {
    return useGet<IContestListParams, IContestNotice[]>('contestNotice/list', {});
  }
  static queryById() {
    return useGet<IQueryByIdParams, IContestNotice>('contestNotice/queryById', {});
  }
}
